/** Esquemas aceitos no destino do clique: é um link que o app abre. */
const ALLOWED_PROTOCOLS = ['http:', 'https:'] as const;

/**
 * Diz se o destino do clique do banner é um link aceitável.
 *
 * Vazio é válido — o campo é opcional (banner apenas informativo). Preenchido, o
 * valor precisa ser uma URL absoluta `http`/`https`, como o placeholder da tela
 * sugere: o app abre esse endereço, então `mbx.com.br/promo` (sem esquema) não
 * funciona lá e é recusado aqui. A lista de esquemas também descarta `javascript:`
 * e afins, que não têm o que fazer num destino de banner.
 *
 * @param value - Conteúdo do campo Url, já sem espaços nas pontas.
 *
 * @example
 * ```ts
 * isValidBannerUrl('');                       // true
 * isValidBannerUrl('https://mbx.com.br/x');   // true
 * isValidBannerUrl('mbx.com.br/x');           // false
 * ```
 */
export function isValidBannerUrl(value: string): boolean {
  if (value === '') return true;

  try {
    const parsed = new URL(value);
    return ALLOWED_PROTOCOLS.includes(parsed.protocol as 'http:');
  } catch {
    return false;
  }
}
